import { render, staticRenderFns } from "./GeneralCloseDay.vue?vue&type=template&id=64ac2c94&"
import script from "./GeneralCloseDay.vue?vue&type=script&lang=js&"
export * from "./GeneralCloseDay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports